import React, { useState, useEffect } from "react";
import { retrieveHareKrishnaInventoryData } from "../api/PupilApi";
import { useNavigate } from "react-router-dom";

const Sale = () => {
  const [customer, setCustomer] = useState({
    name: "",
    address: "",
    mobile: "",
    gst: "",
    shipTo: "",
  });

  const [inventory, setInventory] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
   const navigate = useNavigate();
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [product, setProduct] = useState({
    itemName: "",
    mrp: "",
    quantity: 1,
    pricePerUnit: "",
    discount: "",
    gst: "",
  });

  useEffect(() => {
    retrieveHareKrishnaInventoryData("orgData@.com").then((response) => {
      if (response?.data?.data) {
        const products = response.data.data.flatMap(category =>
          category.productSubCategoryList.flatMap(subcategory =>
            subcategory.productInfoList.map(product => ({
              id: product._id,
              itemName: product.productName,
              mrp: parseFloat(product.sellingPrice) || 0,
              pricePerUnit: parseFloat(product.sellingPrice) || 0,
              gst: product.gst || 5,
              quantity: 1,
              discount: 0,
              amount: parseFloat(product.sellingPrice) || 0,
            }))
          )
        );
        setInventory(products);
        setFilteredProducts(products);
      }
    });
  }, []);

  const handleCustomerChange = (e) => {
    setCustomer({ ...customer, [e.target.name]: e.target.value });
  };

  const handleProductChange = (e) => {
    setProduct({ ...product, [e.target.name]: e.target.value });
  };

  const addProduct = () => {
    const newProduct = { ...product, amount: product.mrp * product.quantity };
    setSelectedProducts([...selectedProducts, newProduct]);
    setProduct({ itemName: "", mrp: "", quantity: 1, pricePerUnit: "", discount: "", gst: "" });
  };

  const removeProduct = (index) => {
    setSelectedProducts(selectedProducts.filter((_, i) => i !== index));
  };

  return (
    <div className="container mx-auto p-6">
      <h2 className="text-xl font-bold mb-4">Sale Form</h2>
      <button onClick={() => navigate(-1)} className="bg-gray-500 text-white px-6 py-3 rounded-md hover:bg-gray-600 text-lg font-bold">
          Back
        </button>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Left Side - Customer & Product Form */}
        <div className="border p-4 rounded-md shadow-md">
          <h3 className="text-lg font-semibold mb-2">Customer Details</h3>
          <div className="grid grid-cols-2 gap-4">
            {["name", "address", "mobile", "gst", "shipTo"].map((field) => (
              <div key={field} className="flex flex-col">
                <label className="font-medium capitalize">{field}</label>
                <input
                  type="text"
                  name={field}
                  value={customer[field]}
                  onChange={handleCustomerChange}
                  className="border p-2 rounded"
                  placeholder={`Enter ${field}`}
                />
              </div>
            ))}
          </div>

          <h3 className="text-lg font-semibold mt-4 mb-2">Add Product</h3>
          <div className="grid grid-cols-6 gap-4">
            {["itemName", "mrp", "quantity", "pricePerUnit", "discount", "gst"].map((field) => (
              <div key={field} className="flex flex-col">
                <label className="font-medium capitalize">{field.replace(/([A-Z])/g, " $1")}</label>
                <input
                  type="text"
                  name={field}
                  value={product[field]}
                  onChange={handleProductChange}
                  className="border p-2 rounded"
                  placeholder={`Enter ${field}`}
                />
              </div>
            ))}
          </div>

          <button
            className="mt-4 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
            onClick={addProduct}
          >
            Add Product
          </button>
        </div>

        {/* Right Side - Added Products List */}
        <div className="border p-4 rounded-md shadow-md">
          <h3 className="text-lg font-semibold mb-2">Added Products</h3>

          {selectedProducts.length > 0 ? (
            <table className="w-full border">
              <thead>
                <tr className="bg-gray-200">
                  <th className="border p-2">Item Name</th>
                  <th className="border p-2">MRP</th>
                  <th className="border p-2">Qty</th>
                  <th className="border p-2">Price/Unit</th>
                  <th className="border p-2">Discount%</th>
                  <th className="border p-2">GST%</th>
                  <th className="border p-2">Amount</th>
                  <th className="border p-2">Action</th>
                </tr>
              </thead>
              <tbody>
                {selectedProducts.map((p, index) => (
                  <tr key={index} className="text-center">
                    <td className="border p-2">{p.itemName}</td>
                    <td className="border p-2">{p.mrp}</td>
                    <td className="border p-2">
                      <input
                        type="number"
                        value={p.quantity}
                        min="1"
                        className="w-16 border"
                        onChange={(e) => {
                          const updated = [...selectedProducts];
                          updated[index].quantity = parseInt(e.target.value) || 1;
                          updated[index].amount = updated[index].mrp * updated[index].quantity;
                          setSelectedProducts(updated);
                        }}
                      />
                    </td>
                    <td className="border p-2">{p.pricePerUnit}</td>
                    <td className="border p-2">
                      <input
                        type="number"
                        value={p.discount}
                        min="0"
                        max="100"
                        className="w-16 border"
                        onChange={(e) => {
                          const updated = [...selectedProducts];
                          updated[index].discount = parseFloat(e.target.value) || 0;
                          updated[index].amount = updated[index].mrp * updated[index].quantity * (1 - updated[index].discount / 100);
                          setSelectedProducts(updated);
                        }}
                      />
                    </td>
                    <td className="border p-2">{p.gst}%</td>
                    <td className="border p-2">₹{p.amount.toFixed(2)}</td>
                    <td className="border p-2">
                      <button
                        className="bg-red-500 text-white px-2 py-1 rounded"
                        onClick={() => removeProduct(index)}
                      >
                        Remove
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p className="text-gray-500">No products added</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Sale;
